import React, { useState, useEffect, useRef } from 'react'
import { useLocation } from 'react-router-dom'
import { useGeoState, useGeoFetch } from '../../components/GeoProvider'
import ErrorMessage from '../../components/Layout/ErrorMessage'
import Spinner from '../../components/Loader/Spinner'
import EmptyMap from '../../components/Map/emptyMap'
import Map from '../../components/Map'
import Timeline from '../../components/Timeline'
import toolTipFormatter from './toolTipFormatter'
import VulMapLegend from './vulnerabilityMapLegendHorizontal'
import SideTable from './SideTable'
import styles from './MapPage.module.scss'
import dayjs from 'dayjs'
import DisplayDateProvider from '../../components/DisplayDateProvider/DisplayDateProvider'
const DashboardMap = ({ zoomLocation }) => {  
  const chartRef = useRef(null)
  const location = useLocation()
  const hash = location.hash
  const slotTimeInSeconds = 604800000
  const latestPositionString = ''
  const slotString = 'week'
  const [getMapStates, setMapStates] = useState()
  const [metros, setMetros] = useState()
  const [getStats, setStats] = useState()
  const [getMSAStats, setMSAStats] = useState()
  const [errorCode, setErrorCode] = useState()
  const [errorMessage, setErrorMessage] = useState()
  const [errorSubject, setErrorSubject] = useState()
  const [errorOccured, seterrorOccured] = useState(false)
  const [getStateJson, setStateJson] = useState()
  const [getCBSAJsonData, setCBSAJsonData] = useState()
  const [activeCbsa, setActiveCbsa] = useState()
  const {
    dataStartDate,
    dataEndDate,
    mapOptions,
    regionSelected,
    setRegionSelected,
    displayDate,
    setDisplayDate,
    setExportButtonEnable
  } = useGeoState()


const lastweekEndDate = dayjs().day(-1).format('YYYY-MM-DD')
  if (hash) {
    if (hash.split('-').length > 1) {
      setRegionSelected(hash.split('-')[0].replace('#', ''))
    }
  }

  // const { data: medData, error: medDataError } = useGeoFetch(
  //   lastweekEndDate,
  //   lastweekEndDate,
  //   'vulnerability',
  //   'getmedicalfactor'
  // )

  // useEffect(() => {
  //   if (medData !== null && medData !== undefined) {
  //     if (medData.response_code === 200) {
  //       setMedicalFactorData(medData.response_data)
  //     } else {
  //       setErrorCode(medData.response_code)
  //       setErrorMessage(medData.response_message)
  //       setErrorSubject(medData.response_subject)
  //       seterrorOccured(true)
  //     }
  //   }
  // }, [medData])

  const { data: statesData, error: MapError } = useGeoFetch(
    dataStartDate,
    dataEndDate,
    'vulnerability',
    'getdashmap/STATE?geo_parent=US'
  )

  useEffect(() => {
    if (statesData !== null && statesData !== undefined) {
      if (statesData.response_code === 200) {    
        var datacount= Object.keys(statesData.response_data).length-1                
        setDisplayDate(Object.keys(statesData.response_data).sort()[datacount])
        setMapStates(statesData.response_data)
      } else {
        setErrorCode(statesData.response_code)
        setErrorMessage(statesData.response_message)
        setErrorSubject(statesData.response_subject)
        seterrorOccured(true)
      }
    }
  }, [statesData])

  const { data: msaData, error: MapmsaError } = useGeoFetch(
    dataStartDate,
    dataEndDate,
    'vulnerability',
    'getdashmap/MSA?geo_parent='
  )

  useEffect(() => {
    if (msaData !== null && msaData !== undefined) {
      if (msaData.response_code === 200) {  
        var datacount= Object.keys(msaData.response_data).length-1                
        setDisplayDate(Object.keys(msaData.response_data).sort()[datacount])      
        setMetros(msaData.response_data)
        setExportButtonEnable(true)
      } else {
        setErrorCode(msaData.response_code)
        setErrorMessage(msaData.response_message)
        setErrorSubject(msaData.response_subject)
        seterrorOccured(true)
      }
    }
  }, [msaData])



  const { data: stats, error: stateDataError } = useGeoFetch(
    lastweekEndDate,
    lastweekEndDate,
    'vulnerability',
    'getsidetable/STATE?geo_parent=US'
  )

  useEffect(() => {
    if (stats !== null && stats !== undefined) {
      if (stats.response_code === 200) {
        setStats(stats.response_data)
      } else {
        setErrorCode(stats.response_code)
        setErrorMessage(stats.response_message)
        setErrorSubject(stats.response_subject)
        seterrorOccured(true)
      }
    }
  }, [stats])

  const { data: msaStats, error: msaDataError } = useGeoFetch(
    lastweekEndDate,
    lastweekEndDate,
    'vulnerability',
    'getsidetable/MSA?geo_parent='
  )

  useEffect(() => {
    if (msaStats !== null && msaStats !== undefined) {
      if (msaStats.response_code === 200) {
        setMSAStats(msaStats.response_data)
      } else {
        setErrorCode(msaStats.response_code)
        setErrorMessage(msaStats.response_message)
        setErrorSubject(msaStats.response_subject)
        seterrorOccured(true)
      }
    }
  }, [msaStats])

  const { data: activeCbsasData, error: activeCbsasDataError } = useGeoFetch(
    dataStartDate,
    dataEndDate,
    'vulnerability',
    'getactivelocations?geo_type=MSA'
  )

  useEffect(() => {
    if (activeCbsasData !== null && activeCbsasData !== undefined) {
      if (activeCbsasData.response_code === 200) {
        setActiveCbsa(activeCbsasData.response_data)
      } else {
        setErrorCode(stats.response_code)
        setErrorMessage(stats.response_message)
        setErrorSubject(stats.response_subject)
        seterrorOccured(true)
      }
    }
  }, [activeCbsasData])

  useEffect(() => {
    let url = `${window.location.origin}/vulnerability/usStatesAll.json`
    fetch(url)
      .then(function (res) {
        return res.json()
      })
      .then(function (data) {
        setStateJson(data)
      })
      .catch(function (err) {
        console.log(err, ' error file usStatesAll.json')
      })
  }, [1])
  useEffect(() => {
    let url = `${window.location.origin}/vulnerability/cb_2018_us_cbsa_20m_wkid102004.json`
    fetch(url)
      .then(function (res) {
        return res.json()
      })
      .then(function (data) {
        setCBSAJsonData(data)
      })
      .catch(function (err) {
        console.log(err, ' error file us_hrr_values ')
      })
  }, [1])

  if ( MapError ||msaDataError||MapmsaError|| errorOccured) {
    return (
      <ErrorMessage
        errorCode={errorCode}
        errorMessage={errorMessage}
        errorSubject={errorSubject}
        errorDetails={errorMessage}
      />
    )
  }
  return (
    <div className={`${styles.base}`}>
      <div className={`${styles.cbsasPanel}`}>
        <>
          {regionSelected === 'state' && (
            <>
              {getStats !== undefined ? (
                <SideTable stateData={getStats} chartRef={chartRef} />
              ) : (
                <div style={{ border: '1.5px solid #CBCCCD', height: '84vh' }}>
                  <Spinner />
                </div>
              )}
            </>
          )}
           {regionSelected === 'metro' && (
            <>
              {getMSAStats !== undefined ? (
                <SideTable stateData={getMSAStats} chartRef={chartRef} />
              ) : (
                <div style={{ border: '1.5px solid #CBCCCD', height: '84vh' }}>
                  <Spinner />
                </div>
              )}
            </>
          )}
        </>
      </div>
      <div className={`${styles.map}`}>
        {regionSelected === 'state' && (
          <>
            {getMapStates !== undefined && getStateJson ? (
              <>
                <div className={`${styles.providerHeader}`}>
               <DisplayDateProvider
                textShow={'Respiratory Virus Activity '}
                        showWeek={false}
                        lastweekEndDate={displayDate}
                        dashType={'VULNERABILITY'}
                      />
                      <Timeline
                      statesData={getMapStates}
                      latestPositionString={latestPositionString}
                      slotString={slotString}
                      slotTimeInSeconds={slotTimeInSeconds}
                      markCounts={15}
                      loadError={stateDataError}
                      dashboardType={'VULNERABILITY'}
                  />
                  
               </div>
              
               <div className={styles.legendDiv}>
                <VulMapLegend />
                </div>
                <Map
                  toolTipFormatter={toolTipFormatter}
                  activeCbsasData={null}
                  statesData={getMapStates}
                  cbsaData={null}
                  mapOptions={mapOptions}
                  dynamicMapTitle={true}
                  mapType="rsvmap"
                  enableButtons={true}
                  chartRef={chartRef}
                  mapDataType={0}
                  stateJson={getStateJson}
                  dashboardType="Vulnerability"
                />

               
              </>
            ) : (
             
              <EmptyMap stateJson={getStateJson} />
            )}
          </>
        )}
         {regionSelected === 'metro' && (
          <>
            {metros !== undefined && 
            getCBSAJsonData!==undefined && 
            activeCbsa!==undefined ? (
              <>
                <div className={`${styles.providerHeader}`}>
               <DisplayDateProvider
                textShow={'Respiratory Virus Activity '}
                showWeek={false}
                lastweekEndDate={displayDate}
                dashType={'VULNERABILITY'}
                      />
                      <Timeline
                    statesData={getMapStates}
                    latestPositionString={latestPositionString}
                    slotString={slotString}
                    slotTimeInSeconds={slotTimeInSeconds}
                     markCounts={15}
                    loadError={stateDataError}
                    dashboardType={'VULNERABILITY'}
                  />
                  
               </div>
              
               <div className={styles.legendDiv}>
                <VulMapLegend />
                </div>
                <Map
                  toolTipFormatter={toolTipFormatter}
                  activeCbsasData={activeCbsa}
                  statesData={getMapStates}
                  cbsaData={metros}
                  mapOptions={mapOptions}
                  dynamicMapTitle={true}
                  mapType="rsvmapmsa"
                  enableButtons={true}
                  zoomLocation={zoomLocation}
                  chartRef={chartRef}
                  mapDataType={1}
                  //mapDataType={geo_type === 'state' ? 0 : 1}
                  JsonData={getCBSAJsonData}
                  stateJson={getStateJson}
                 
                  dashboardType="Vulnerability"
                />

               
              </>
            ) : (
             
               <EmptyMap stateJson={getStateJson} />
            )}
          </>
        )}
      </div>
    </div>
  )
}

export default DashboardMap
